import { Field } from 'react-final-form';

import { Textarea as TextareaTHC } from '@motorway/mw-highway-code/pre-alpha';

import { Label } from './FormHelpers';
import { getIntent, logOnFieldComplete, required } from './forms.helpers';

export const Textarea = ({ name, label }: { name: string; label: string }) => {
  return (
    <section>
      <Field name={name} validate={required}>
        {({ input, meta }) => (
          <TextareaTHC
            formProps={{
              input: {
                ...input,
                onBlur: logOnFieldComplete(meta, input.onBlur),
              },
            }}
            fullWidth
            id={name}
            intent={getIntent(meta)}
            label={Label(label)}
            showLabel
          />
        )}
      </Field>
    </section>
  );
};
